import React, { useState } from "react";
import Layout from "../../components/vendorManager/Layout";
import Helmet from "react-helmet";
import Table from "../../components/ui/Table";
import usePaginate from "../../hooks/api/usePaginate";
import apiRequest from "../../utils/vendorManager/apiRequest";
import Pagination from "../../components/ui/Pagination";
import { useSelector } from "react-redux";
import OrderDetails from "../../components/vendorManager/order/OrderDetails";
import Modal from "../../components/ui/utils/Modal";
import { FaEye } from "react-icons/fa";
import useModal from "../../hooks/ui/useModal";
import { Link } from "react-router-dom";
import { ORDER_DEATILS_PRODUCT_ROUTE } from "../../routes/vendorManager/vendorRoutes";

const Orders = () => {
  const [filters, setFilters] = useState({
    search: "",
    mobile: "",
    corporateCode: "",
  });

  const { isOpen, openModal, closeModal, actionType } = useModal();


  const {
    currentPage,
    data,
    fetchData,
    limit,
    loading,
    setPage,
    setSorting,
    sort,
    totalItems,
    totalPages,
  } = usePaginate({
    apiMethod: apiRequest.getVendorOrders,
    dataKey: "orders",
    extraParams: filters,
  });

  const BRAND_NAME = useSelector(
    (state) => state.globalState.siteSetting?.site_settings?.site_name
  );

  const handleSort = (field) => {
    const order =
      sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
    setSorting({ sortField: field, sortOrder: order });
  };

  return (
    <Layout>
      <Helmet>
        <title>Vendor Orders - {BRAND_NAME ?? ""}</title>
      </Helmet>

      <div className="p-4 mb-4 bg-white rounded shadow flex gap-3">
        <input
          type="text"
          placeholder="Search by Customer Name..."
          className="border rounded px-3 py-2 text-sm w-1/3"
          onChange={(e) => setFilters({ ...filters, search: e.target.value })}
        />

        <input
          type="text"
          placeholder="Search by Mobile..."
          className="border rounded px-3 py-2 text-sm w-1/3"
          onChange={(e) => setFilters({ ...filters, mobile: e.target.value })}
        />

        <input
          type="text"
          placeholder="Corporate Code..."
          className="border rounded px-3 py-2 text-sm w-1/3"
          onChange={(e) =>
            setFilters({ ...filters, corporateCode: e.target.value })
          }
        />

        <button
          onClick={() => fetchData(1)}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Filter
        </button>
      </div>

      {/* ORDER TABLE */}
      <div className="p-4 bg-white rounded shadow">
        <h2 className="text-lg font-semibold mb-3">My Orders</h2>

        <Table
          headers={[
            { label: "Order ID", key: "orderId", sorting: false },
            { label: "Customer", key: "userId.name", sorting: false },
            { label: "Mobile", key: "userId.mobile", sorting: false },
            { label: "Corporate Code", key: "userId.corporateCode", sorting: false },
            { label: "Items", key: "products", sorting: false },
            { label: "Total Amount", key: "totalAmount", sorting: true },
            { label: "Status", key: "status", sorting: true },
            { label: "Actions", key: "action", sorting: false },
          ]}
          loading={loading}
          sort={sort}
          handleSort={handleSort}
          cols={12}
          renderRow={
            <tbody>
              {data?.map((order) => (
                <OrderRow isOpen={isOpen} Link={Link} fetchData={fetchData} openModal={openModal} closeModal={closeModal} actionType={actionType} key={order._id} order={order} />
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}
      </div>
    </Layout>
  );
};

const OrderRow = ({ order, Link, openModal, closeModal, actionType, isOpen, fetchData }) => {

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-3 py-2 font-semibold">#{order.orderId}</td>
        <td className="px-3 py-2">{order.userId?.name}</td>
        <td className="px-3 py-2 text-sm">{order.userId?.mobile}</td>
        <td className="px-3 py-2 text-sm">{order.userId?.corporateCode ?? "-"}</td>
        <td className="px-3 py-2">{order.products.length} items</td>

        <td className="px-3 py-2 font-semibold text-green-700">
          ₹{order.totalAmount.toFixed(2)}
        </td>

        <td className="px-3 py-2">
          <span
            className={`px-2 py-1 rounded text-xs ${order?.status === "Completed"
              ? "bg-green-100 text-green-700"
              : order?.status === "Pending"
                ? "bg-yellow-100 text-yellow-700"
                : order?.status === "Cancelled"
                  ? "bg-red-100 text-red-700"
                  : "bg-gray-100 text-gray-700"
              }`}
          >
            {order?.status}
          </span>
        </td>

        <td className="px-3 py-2">
          <Link
            to={ORDER_DEATILS_PRODUCT_ROUTE(order?._id)}
            className="text-primary"
            title="View Details"
          >
            <FaEye size={18} />
          </Link>


        </td>
      </tr>


    </>
  );
};

export default Orders;
